import React from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DollarOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

/**
 * El ícono de un paso del flujo con otro chiquito abajo a la derecha, un poco superpuesto,
 * que dice en qué está: el signo pesos en los pasos del pago, la factura en los de la
 * factura. Toma el color del paso, igual que los otros íconos del flujo. El fondo de la
 * marca es el del círculo (`--fondo-icono` en `config.css`), para que se separe del ícono.
 */
const IconoConMarca: React.FC<{
  base?: React.ReactNode;
  marca: React.ReactNode;
}> = ({ base = <DollarOutlined />, marca }) => (
  <span className="icono-pago-marca">
    {base}
    <span className="icono-pago-marca__marca">{marca}</span>
  </span>
);

/** Pago pendiente: con un signo de admiración. */
export function PagoPendienteIcon() {
  return <IconoConMarca marca={<ExclamationCircleOutlined />} />;
}

/** Revisión de pago: con un ojo, alguien lo está mirando (Diseño, 2026-10-19). */
export function PagoEnRevisionIcon() {
  return <IconoConMarca marca={<EyeOutlined />} />;
}

/** Pago verificado: con un check. */
export function PagoVerificadoIcon() {
  return <IconoConMarca marca={<CheckCircleOutlined />} />;
}

/** Factura aprobada —de un pedido o de una nota de crédito—: la factura con un check. */
export function FacturaAprobadaIcon() {
  return (
    <IconoConMarca base={<FileTextOutlined />} marca={<CheckCircleOutlined />} />
  );
}

/** Factura pendiente —de una nota de crédito—: la factura con un signo de admiración. */
export function FacturaPendienteIcon() {
  return (
    <IconoConMarca
      base={<FileTextOutlined />}
      marca={<ExclamationCircleOutlined />}
    />
  );
}

/** Pago cancelado: con una cruz. */
export function PagoCanceladoIcon() {
  return <IconoConMarca marca={<CloseCircleOutlined />} />;
}
